import { getApi } from "../../services/httpService";


export function companyInfo(){
    return getApi().get('home/companyInfo');
}